import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { fadeIn, fadeInUp, fadeInUpSmall } from "../../lib/animations";

export function FinalClosingSection({ navigate }) {
  return (
    <section className="relative z-10 px-6 md:px-12 lg:px-24 py-24 bg-[#0A0A0F] overflow-hidden">
      <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.4) 1px, transparent 0)', backgroundSize: '32px 32px' }} />

      <div className="max-w-3xl mx-auto text-center relative">
        <motion.div
          initial={fadeInUpSmall.initial}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.05 }}
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-5">
            Ready to Dominate Your Market?
          </h2>

          <p className="text-gray-400 text-base md:text-lg max-w-xl mx-auto leading-relaxed mb-10">
            Put AI to work winning listings, launching ads in minutes, and never missing a lead.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
            <Button
              onClick={() => navigate('/pricing')}
              className="bg-[#39FF14] text-black hover:bg-[#32E012] font-semibold px-8 py-5 text-base h-auto shadow-lg shadow-[#39FF14]/20"
              data-testid="final-cta-primary"
            >
              Get Founding Member Access <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <Button
              variant="outline"
              onClick={() => document.getElementById('video-demo')?.scrollIntoView({ behavior: 'smooth' })}
              className="border-white/20 text-gray-300 hover:border-[#39FF14]/50 hover:text-[#39FF14] font-medium px-8 py-5 text-base h-auto bg-transparent"
              data-testid="final-cta-demo"
            >
              Watch Demo
            </Button>
          </div>

          <p className="text-gray-600 text-sm mb-8">
            Founding Member pricing locks in for life. Cancel anytime.
          </p>

          <div className="flex items-center justify-center gap-3 text-xs text-gray-500">
            <span className="bg-white/[0.06] border border-white/10 px-3 py-1 rounded-full">Solo Agent</span>
            <span className="text-gray-700">&middot;</span>
            <span className="bg-white/[0.06] border border-white/10 px-3 py-1 rounded-full">Market Leader</span>
            <span className="text-gray-700">&middot;</span>
            <span className="bg-white/[0.06] border border-white/10 px-3 py-1 rounded-full">Brokerage</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
